import { PremiumSectionItem } from "./premiumSectionItem.model"

export class PremiumSection {
    constructor(
        public label: string,
        public preposition: string,
        public cardType: string,
        public description: string,
        public items: PremiumSectionItem[]
    ) {}

    public static fromData(data): PremiumSection {
        return new PremiumSection(
            data.section_name,
            data.preposition,
            data.card_type,
            data.description,
            data.items.map((item_data) => PremiumSectionItem.fromData(item_data))
        )
    }
}
